import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { InputLabel } from '@material-ui/core';
import { InputProps } from './types';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { ErrorMessage } from '../Services/styled-components';
import ClinicMasterProductSelector from '../ClinicMasterProductsSelector';

interface ClinicMasterProductsSelectorEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
    clinicId: string;
  }

function ClinicMasterProductsSelectorEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  clinicId,
}: ClinicMasterProductsSelectorEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState }) => (
        <StyledQuestionFieldContainer>
          <InputLabel error={Boolean(fieldState.error)}>Clinic master products</InputLabel>
          <ClinicMasterProductSelector clinicId={clinicId} value={value} onChange={onChange} />
          <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default ClinicMasterProductsSelectorEditor;
